import { useDrop } from 'react-dnd';
import { useMultiCommon } from './useMultiCommon';
export var useMultiDrop = function useMultiDrop(spec) {
  return useMultiCommon(spec, useDrop);
};